export default "__VITE_ASSET__eebc24a9__"